<div class="row">
    <div class="col-12">
        <h3>Unauthorised access</h3>
        <p>{{ message }}</p>
        <br />
        <p *ngIf="!supportRequest">
            If you should have access to this site, please click
            <a
                class="btn-link"
                [routerLink]="['/login']"
            >here
            </a> to log in
        </p>
        <p *ngIf="supportRequest">
            Please click
            <a
                class="btn-link"
                [routerLink]="['/login']"
            >here
            </a> to log in and try again
        </p>
    </div>
</div>
